<template>
    <div class="admin-operation">
        <b-button v-b-modal="operationName">{{ $translate(operationName) }}</b-button>

        <b-modal :id="operationName" :title="formTitle" :hide-footer="true" size="lg">
            <create-update-tenant-form
                v-if="isCreateTenantOperation || isUpdateTenantOperation"
                :is-update-mode="isUpdateTenantOperation"
            />
            <create-update-user-form
                v-if="isCreateUserOperation || isUpdateUserOperation"
                :is-update-mode="isUpdateUserOperation"
            />
            <create-connector-form v-if="isCreateConnectorOperation" />
            <update-connector-form v-if="isUpdateConnectorOperation" />
        </b-modal>
    </div>
</template>

<script>
import CreateUpdateTenantForm from './forms/CreateUpdateTenantForm.vue'
import CreateUpdateUserForm from './forms/CreateUpdateUserForm'
import CreateConnectorForm from './forms/CreateConnectorForm'
import UpdateConnectorForm from './forms/UpdateConnectorForm'

export default {
    name: 'AdminOperation',
    components: {
        UpdateConnectorForm,
        CreateConnectorForm,
        CreateUpdateTenantForm,
        CreateUpdateUserForm
    },
    props: {
        operationName: {
            type: String,
            required: true
        }
    },
    computed: {
        formTitle() {
            return this.$translate(this.operationName) + ' Form'
        },
        isCreateTenantOperation() {
            return this.operationName === 'create_tenant'
        },
        isUpdateTenantOperation() {
            return this.operationName === 'update_tenant'
        },
        isCreateUserOperation() {
            return this.operationName === 'create_user'
        },
        isUpdateUserOperation() {
            return this.operationName === 'update_user'
        },
        isCreateConnectorOperation() {
            return this.operationName === 'create_connector'
        },
        isUpdateConnectorOperation() {
            return this.operationName === 'update_connector'
        }
    }
}
</script>

<style lang="scss" scoped >
.admin-operation {
    .btn {
        font-size: 2.5rem;
        border-radius: unset;
        width: 15rem;
        height: 15rem;
        &:hover {
            background-color: $blue !important;
            color: $dark;
        }
    }
}
</style>
